export default (state = {}, action) => {
  switch (action.type) {
    case 'experimentDataReceived':
      return {
        ...state,
        [action.payload.experiment_id]: {
          isLoadingVariant: false,
          variant: action.payload.variant
        }
      }
    case 'fetchExperimentDataError':
      return {
        ...state,
        [action.payload.experiment_id]: {
          isLoadingVariant: false
        }
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./common/reducers/experiments.js